import { render } from "./ProfileSiAdmin.vue?vue&type=template&id=45bd643c&scoped=true"
import script from "./ProfileSiAdmin.vue?vue&type=script&lang=js"
export * from "./ProfileSiAdmin.vue?vue&type=script&lang=js"

import "./ProfileSiAdmin.vue?vue&type=style&index=0&id=45bd643c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bd643c"]])

export default __exports__